import StateRepository from '@/shared/http/repositories/core/state'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import * as mutation from './mutationTypes'
import { actionTypes as action } from './actionTypes'

export const actions = {
  [action.FETCH_STATES]: async ({ commit }) => {
    try {
      loading.push()

      const res = await StateRepository.GetAll()
      if (!IsSuccessCode(res)) return Promise.reject()

      commit(mutation.SET_STATES, res.data.data)
      loading.pop()
      return Promise.resolve()
    } catch (error) {
      loading.pop()
      toast.error('Erro ao carregar estados', 'ERRO')
    }
  }
}
